import { render, staticRenderFns } from "./AppCostsPieChart.vue?vue&type=template&id=3127e523&"
import script from "./AppCostsPieChart.vue?vue&type=script&lang=js&"
export * from "./AppCostsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports